import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import EventEmitter from '../../../utils/eventEmitter';
import useLotSerialNumberAPI from '../../apis/lotSerialNumberAPI';
import dayjs from 'dayjs';

const LotSerialNumberChanges = () => {
  const {products, lotSerialNumber} = useLoaderData();
  lotSerialNumber['expiration_date'] = lotSerialNumber.expiration_date ? dayjs(lotSerialNumber['expiration_date'], 'YYYY-MM-DD') : '';
  lotSerialNumber['removal_date'] = lotSerialNumber.removal_date ? dayjs(lotSerialNumber['removal_date'], 'YYYY-MM-DD') : '';
  lotSerialNumber['best_before_date'] = lotSerialNumber.best_before_date ? dayjs(lotSerialNumber['best_before_date'], 'YYYY-MM-DD') : '';
  lotSerialNumber['alert_date'] = lotSerialNumber.alert_date ? dayjs(lotSerialNumber['alert_date'], 'YYYY-MM-DD') : '';
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState(lotSerialNumber.number ? lotSerialNumber.number : '');
  const { create, update } = useLotSerialNumberAPI();
  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['number'] = name;
    create(data, success);
    // console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['number'] = name;
    update(lotSerialNumber.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };


  useEffect(() => {
    EventEmitter.subscribe('lotSerialNumbers_created', data => {
      navigate('/inventory/lots-serial-numbers/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('lotSerialNumbers_created');
    }
  },[])


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/lots-serial-numbers'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Lots Serial Numbers</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ lotSerialNumber.number ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {lotSerialNumber.number && <Button onClick={edit}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Lot/Serial Number"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ md: {span: 4} }}
          labelWrap={true}
          initialValues={lotSerialNumber.number ? lotSerialNumber : {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item label='Product' name='product_id' className='font-semibold text-gray-800 mb-4' required >
            <Select options={products.map(product => ({value: product.id, label: product.name}))}/>
          </Form.Item>
          <Form.Item label='Quantity' name='quantity' className='font-semibold text-gray-800 mb-4' required >
            <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal w-full' />
          </Form.Item>     
          <Form.Item label='Internal Reference' name='internal_reference' className='font-semibold text-gray-800 mb-4' required >
            <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' />
          </Form.Item>
          <Tabs 
            className='mt-4'
            type='card'
            items={[
              {
                key: 1,
                label: 'Dates',
                children: 
                  <Row>
                    <Col md={{span: 11}}>
                      <Form.Item labelCol={{md: {span: 8}}} label='Expiration Date' name='expiration_date' className='font-semibold text-gray-800 mb-4' required >
                        <DatePicker className='w-full' />
                      </Form.Item> 
                      <Form.Item labelCol={{md: {span: 8}}} label='Removal Date' name='removal_date' className='font-semibold text-gray-800 mb-4' required >
                        <DatePicker className='w-full' />
                      </Form.Item> 
                    </Col>
                    <Col md={{span: 11, offset: 1}}>
                      <Form.Item labelCol={{md: {span: 8}}} label='Best before Date' name='best_before_date' className='font-semibold text-gray-800 mb-4' required >
                        <DatePicker className='w-full' />
                      </Form.Item> 
                      <Form.Item labelCol={{md: {span: 8}}} label='Alert Date' name='alert_date' className='font-semibold text-gray-800 mb-4' required >
                        <DatePicker className='w-full' />
                      </Form.Item> 
                    </Col>
                  </Row>
              },
              {
                key: 2,
                label: 'Description',
                children: 
                  <Form.Item labelCol={{md: {span: 3}}} label='Description' name='description' className='font-semibold text-gray-800 mb-4' required >
                    <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' placeholder='Add any extra information here :)' />
                  </Form.Item>   
              },
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default LotSerialNumberChanges;